import http from "../AppConfig";

class GeneralService {
  sendLogger(hash, path, logger) {
    return http.post(`logs?hash=${hash}&url=${path}`, logger);
  }

  createHashCode(length) {
    let hash = "";
    let alphaCharacters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < length; i++) {
      hash += alphaCharacters.charAt(
        Math.floor(Math.random() * alphaCharacters.length)
      );
    }

    return hash;
  }
}

export default new GeneralService();
